const FUNCTIONS_BASE = "/.netlify/functions";

const request = async (functionName, params = {}) => {
  const query = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== null && value !== ""
      )
    )
  );
  const suffix = query.toString() ? `?${query}` : "";
  const response = await fetch(`${FUNCTIONS_BASE}/${functionName}${suffix}`);
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || `Unable to load ${functionName}`);
  }
  return data;
};

const getResults = async (functionName, params) => {
  const data = await request(functionName, params);
  return Array.isArray(data.results) ? data.results : [];
};

export const fetchTrendingMovies = () => getResults("trending");
export const fetchTopRatedMovies = () => getResults("topRatedMovies");
export const fetchMoviesByGenre = (genreId) =>
  getResults("moviesByGenre", { genreId });

export const fetchPopularTVShows = () => getResults("popularTV");
export const fetchTopRatedTVShows = () => getResults("topRatedTV");
export const fetchTVShowsByGenre = (genreId) =>
  getResults("tvByGenre", { genreId });

export const fetchDetail = (type, id) =>
  request("detail", { type, id });

export const fetchVideos = (type, id) =>
  getResults("videos", { type, id });

export const fetchCredits = async (type, id) => {
  const data = await request("credits", { type, id });
  return Array.isArray(data.cast) ? data.cast : [];
};

export const fetchSeason = (id, season) =>
  request("season", { id, season });

export const fetchWatchProviders = async (type, id) => {
  const data = await request("watchProviders", { type, id });
  return data.results || {};
};

export const searchMulti = (query) =>
  getResults("search", { query });
